/**
 *
 *  ? url pada submenu menggunakan naming routes,
 *  ? jadi tidak perlu dibuat format url lengkap
 */

export default [
  {
    icon: "CheckCircleIcon",
    menu: "1. Putusan Tugas AKhir",
    url: "koorta-tugas-akhir-keputusan",
  },

  {
    icon: "UserIcon",
    menu: "2. Pembimbing",
    url: "koorta-tugas-akhir-pembimbing",
  },
  {
    icon: "UserIcon",
    menu: "3. Seminar Proposal",
    url: "koorta-tugas-akhir-seminar-proposal",
  },
  {
    icon: "UserIcon",
    menu: "4. Seminar Tugas Akhir",
    url: "koorta-tugas-akhir-seminar-kolokium",
  },
  {
    icon: "UserIcon",
    menu: "5. Yudisium",
    url: "koorta-tugas-akhir-seminar-yudisium",
  },
  {
    icon: "UserIcon",
    menu: "Data Tugas Akhir",
    url: "koorta-data-tugas-akhir",
  },
  {
    icon: "ListIcon",
    menu: "Peminatan",
    url: "koorta-tugas-akhir-peminatan",
  },
];
